exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loadingButton{position:relative;overflow:hidden}.loadingButton .text{position:relative;transition:left .5s linear}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/loading_button.scss
// module id = 1480
// module chunks = 0